export const columnHeader = [
  {
    key: 'location', name: 'Location', type: 'text', system: false, filter: true
  },
  {
    key: 'subnets', name: 'Subnets', type: 'text', system: false, filter: false
  }
];